export default function fitTooltips() {

const fitDimensionsContainer = document.querySelector(
    '.cultural-fit-dimensions'
);

if (fitDimensionsContainer) {

  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const bubble = document.getElementById('bubble');
  const bubbleText = document.getElementById('bubble-text');

  document.querySelectorAll('.dimension').forEach(el => {
    if (!isTouch) {
      const tooltip = document.createElement('div');
      tooltip.className = 'tooltip';
      tooltip.textContent = el.dataset.elementText;
      el.appendChild(tooltip);
    } else {
      el.addEventListener('click', (e) => {
        const rect = el.getBoundingClientRect();
        bubbleText.textContent = el.dataset.elementText;

        bubble.style.top = (window.scrollY + rect.bottom + 6) + "px";
        bubble.style.left = (window.scrollX + rect.left + rect.width/2) + "px";
        bubble.style.transform = "translateX(-50%)";

        bubble.style.display = 'block';
      });
    }
  });

  document.querySelector('.bubble-close').addEventListener('click', () => {
    bubble.style.display = 'none';
  });

  document.addEventListener('click', (e) => {
    if (isTouch && bubble.style.display === 'block') {
      if (!bubble.contains(e.target) && !e.target.classList.contains('dimension')) {
        bubble.style.display = 'none';
      }
    }
  });
}
}